import React from "react";
import TTS from "./TTS";

function App() {
  return (
    <div>
      <TTS />
    </div>
  );
}

export default App;
